var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExport({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5901 17.229C10.5721 17.2303 10.5541 17.2303 10.5361 17.229L1.02012 15.87C0.840886 15.8442 0.676809 15.7551 0.557582 15.6188C0.438354 15.4825 0.371854 15.308 0.370117 15.127V2.86997C0.371107 2.68827 0.437249 2.51295 0.556525 2.37587C0.675801 2.2388 0.840296 2.14906 1.02012 2.12297L10.5351 0.769969C10.5885 0.762713 10.6428 0.766801 10.6945 0.781965C10.7462 0.797128 10.7941 0.823027 10.8351 0.857969C10.8759 0.893422 10.9086 0.937206 10.931 0.986369C10.9535 1.03553 10.9651 1.08893 10.9651 1.14297V16.852C10.9646 16.9517 10.9247 17.0472 10.8541 17.1176C10.7834 17.188 10.6879 17.2277 10.5881 17.228L10.5901 17.229ZM5.40912 10.481L6.42012 12.281H7.93912L6.17012 9.13197L7.93912 5.98597H6.42112L5.40912 7.78597L4.39712 5.98597H2.87812L4.64912 9.13197L2.87812 12.278H4.39712L5.40812 10.478L5.40912 10.481ZM14.7521 15.781H11.7241V14.27H13.9941V3.72497H11.7241V2.21897H14.7511C14.9513 2.2187 15.1434 2.29782 15.2853 2.43898C15.4272 2.58014 15.5073 2.77181 15.5081 2.97197V15.026C15.5076 15.2261 15.4277 15.4179 15.286 15.5592C15.1443 15.7006 14.9523 15.78 14.7521 15.78V15.781Z",
    fill: "#00A9FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.1ac72d625b0ebb8e32a7a975cffa06b4.svg";
export { ForwardRef as ReactComponent };